import { RootState } from "store/reducer";

export const getSortOfScreen = (typeScreen: string) => (state: RootState) => {
  return state.sort[typeScreen];
};
